/**
 * Reference formats match time as moment.tz(mtime, "MM/DD/YYYY hh:mm:ss A", "Asia/Calcutta")
 * converted to the viewer's zone, "DD/MM/YYYY HH:mm:ss".
 */
export function formatRefMatchTime(mtime) {
  const m = String(mtime || "").match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})\s+(\d{1,2}):(\d{2}):(\d{2})\s*(AM|PM)$/i);
  if (!m) return mtime || "";
  let h = Number(m[4]) % 12;
  if (m[7].toUpperCase() === "PM") h += 12;
  // Asia/Calcutta is UTC+05:30 (no DST)
  const d = new Date(Date.UTC(+m[3], +m[1] - 1, +m[2], h, +m[5], +m[6]) - (5 * 60 + 30) * 60000);
  const p = (n) => String(n).padStart(2, "0");
  return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
}
